export default __webpack_public_path__ + "img/dmSUeuTF.85d7fbd4.svg";